import {
  Award,
  Blend,
  Boxes,
  Brush,
  ClipboardCheck,
  Dog,
  Download,
  Ear,
  Eye,
  Feather,
  Gift,
  GraduationCap,
  Images,
  Layers,
  Library,
  ListOrdered,
  MessageSquare,
  PawPrint,
  Scissors,
  SlidersHorizontal,
  Smile,
  Sparkles,
  TrendingUp,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, navy card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Complete Volumes', icon: Library, featured: true },
  { label: 'Complete 6-in-1 Teaching System', icon: Boxes, featured: true },
  { label: '100% Visual Main System', icon: Eye, featured: true },
  { label: 'Beginner to Advanced', icon: TrendingUp, featured: true },
  { label: 'Professional Grooming Foundations', icon: GraduationCap },
  { label: 'Coat Types & Preparation', icon: Layers },
  { label: 'Brushing & De-Shedding', icon: Brush },
  { label: 'Clipper Techniques', icon: Zap },
  { label: 'Blade Selection', icon: SlidersHorizontal },
  { label: 'Body Grooming', icon: Dog },
  { label: 'Scissor Techniques', icon: Scissors },
  { label: 'Blending', icon: Blend },
  { label: 'Professional Styling', icon: Sparkles },
  { label: 'Face & Muzzle Work', icon: Smile },
  { label: 'Feet & Paw Finishing', icon: PawPrint },
  { label: 'Ear Styling', icon: Ear },
  { label: 'Tail Styling', icon: Feather },
  { label: 'Breed Styling', icon: Award },
  { label: 'Visual Technique Breakdowns', icon: Images },
  { label: 'Instructor Cues', icon: MessageSquare },
  { label: 'Common Errors & Corrections', icon: Wrench },
  { label: 'Assessments', icon: ClipboardCheck },
  { label: 'Teaching Progressions', icon: ListOrdered },
  { label: '5 Professional Bonus Guides', icon: Gift },
  { label: 'Immediate Digital Access', icon: Download },
]
